<div class="component-container">
    @if (loading && !hideLoader) {
<ap-loading [colorName]="'a-dark'">
    </ap-loading>
}
    @if (componentMessage) {
<h4 class="component-message">{{componentMessage}}</h4>
}
    @if (componentMessages.length > 0) {
<h4 class="component-message">
        <ul>
            @for (message of componentMessages; track $index) {
<li class="mt-10">{{message}}</li>
}
        </ul>
    </h4>
}
    <ng-template exCompHost></ng-template>
</div>
